import { Button, Empty, Row, Spin } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { PropsWithChildren, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import { FileType } from '@types'
import { useDownload } from '@hooks'

import useTicketFiles from '../../../TicketFiles/hooks'
import InfoSection from '../components/InfoSection'

interface FilesSectionProps {
  files: FileType[]
}

const FilesSection: React.FC<PropsWithChildren<FilesSectionProps>> = ({ files, children }) => {
  const { getFile } = useTicketFiles()
  const { downloadFile, isLoading: isDownloading, keyDowloading } = useDownload()
  const [fileUrl, setFileUrl] = useState<string | undefined>()
  const linkRef = useRef(null)
  const handleOpenFile = (fileId: number) => {
    getFile(fileId, {
      onSuccess: (data: { fileToDownload: string }) => {
        setFileUrl(data.fileToDownload)
        if (linkRef.current) {
          const linkReference = linkRef.current as unknown as HTMLAnchorElement
          linkReference.click()
        }
      },
    })
  }
  return (
    <InfoSection header="Anexos">
      {files?.length ? (
        <>
          {files.map(fileMapped => (
            <Button onClick={() => handleOpenFile(fileMapped.id)} type="link" block size="small">
              <Row justify="space-between" align="middle">
                {fileMapped.fileName.length > 25
                  ? `${fileMapped.fileName.slice(0, 25)}...`
                  : fileMapped.fileName}

                {isDownloading && keyDowloading === fileMapped.ticketFile ? (
                  <Spin spinning size="small" />
                ) : (
                  <DownloadOutlined
                    onClick={() =>
                      downloadFile({ key: fileMapped.ticketFile!, name: fileMapped.fileName })
                    }
                  />
                )}
              </Row>
            </Button>
          ))}
          {fileUrl && (
            <Link
              to={{ pathname: fileUrl }}
              ref={linkRef}
              target="_blank"
              rel="noopener noreferrer"
            />
          )}
        </>
      ) : (
        <Empty />
      )}
      {children}
    </InfoSection>
  )
}

export default FilesSection
